import { HEADERS, TRANSACTION_URL } from './constants';
import instance from './instance';

import { Purchase, RecordTransactionRequest } from './types';
import { PaymentSystem } from '@web-solutions/react-billing';

const getTransaction = (chargeInvoice: any) => {
  const payment_service = chargeInvoice?.data?.payment_service || chargeInvoice?.payment_service || 'recurly';

  if (payment_service === PaymentSystem.SOLIDGATE || payment_service === PaymentSystem.TRUEGATE) {
    return {
      order_id: chargeInvoice?.data?.order_id || chargeInvoice?.order_id,
      payment_service: chargeInvoice?.data?.payment_service || chargeInvoice?.payment_service,
      product_id: chargeInvoice?.data?.product_code || chargeInvoice?.order_id,
      is_one_time_payment: true,
    };
  } else if (payment_service === 'recurly') {
    return {
      order_id: chargeInvoice.chargeInvoiceId || 'chargeInvoice',
      payment_service: 'recurly',
      product_id: chargeInvoice.codename,
      is_one_time_payment: true,
    };
  }
};

export const recordTransaction = async (
  chargeInvoice: any,
  idfm: string,
  purchase: Purchase
): Promise<void> => {
  const transaction = getTransaction(chargeInvoice);

  if (!transaction) {
    return;
  }

  const requestBody: RecordTransactionRequest = {
    transaction,
    token: process.env.REACT_APP_MAGNUS_TOKEN!,
    idfm,
    internal_uid: purchase.email || '',
  };

  try {
    await instance.post(TRANSACTION_URL, requestBody, {
      headers: HEADERS,
    });
  } catch (error) {
    console.warn('recordTransaction', error);
  }
};
